import i18n from "@/i18n/index";

export const TASK_TYPE = [
    {
        name: "appTasksContainer.available",
        id: "Available"
    },
    {
        name: "appTasksContainer.claimed",
        id: "Claimed"
    },
    {
        name: "appTasksContainer.delegated",
        id: "Delegated"
    }
];

export const TASKS_STATUS = [
    {
        name: "appTasksContainer.overdue",
        id: "OVERDUE",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "negative"
    },
    {
        name: "appTasksContainer.atRisk",
        id: "AT_RISK",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "warning"
    },
    {
        name: "appTasksContainer.attention",
        id: "ATTENTION",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "yellow-14"
    },
    {
        name: "appTasksContainer.onTrack",
        id: "ON_TRACK",
        iconName: "mdi-checkbox-blank-circle",
        iconColor: "positive"
    }
];

export const TASK_TYPE_MAPPINGS = {
    "appTasksContainer.available": i18n.t("appTasksContainer.available"),
    "appTasksContainer.claimed": i18n.t("appTasksContainer.claimed"),
    "appTasksContainer.delegated": i18n.t("appTasksContainer.delegated")
};

export const PRIORITY_MAPPINGS = {
    "appTasksContainer.overdue": i18n.t("tasks.filterBy.overdue"),
    "appTasksContainer.atRisk": i18n.t("tasks.filterBy.inWarning"),
    "appTasksContainer.attention": i18n.t("tasks.filterBy.attention"),
    "appTasksContainer.onTrack": i18n.t("tasks.filterBy.onTime")
};

export const TASKS_SORT_OPEN = [
    {
        name: "tasks.priorityName",
        type: "ASC",
        value: "priority",
        icon: "arrow_upward"
    },
    {
        name: "tasks.priorityName",
        type: "DESC",
        value: "priority",
        icon: "arrow_downward"
    },
    {
        name: "tasks.taskName",
        type: "ASC",
        value: "taskName",
        icon: "arrow_upward"
    },
    {
        name: "tasks.taskName",
        type: "DESC",
        value: "taskName",
        icon: "arrow_downward"
    },
    {
        name: "tasks.timeRemaining",
        value: "timeRemaining",
        type: "ASC",
        icon: "arrow_upward"
    },
    {
        name: "tasks.timeRemaining",
        value: "timeRemaining",
        type: "DESC",
        icon: "arrow_downward"
    },
    {
        name: "tasks.creationDateFilter",
        value: "creationDate",
        type: "ASC",
        icon: "arrow_upward"
    },
    {
        name: "tasks.creationDateFilter",
        value: "creationDate",
        type: "DESC",
        icon: "arrow_downward"
    }
];

export const TASKS_SORT_COMPLETED = [
    {
        name: "tasks.priorityName",
        type: "ASC",
        value: "priority",
        icon: "arrow_upward"
    },
    {
        name: "tasks.priorityName",
        type: "DESC",
        value: "priority",
        icon: "arrow_downward"
    },
    {
        name: "tasks.taskName",
        type: "ASC",
        value: "taskName",
        icon: "arrow_upward"
    },
    {
        name: "tasks.taskName",
        type: "DESC",
        value: "taskName",
        icon: "arrow_downward"
    },
    {
        name: "tasks.creationDateFilter",
        value: "creationDate",
        type: "ASC",
        icon: "arrow_upward"
    },
    {
        name: "tasks.creationDateFilter",
        value: "creationDate",
        type: "DESC",
        icon: "arrow_downward"
    },
    {
        name: "tasks.completionDateFilter",
        value: "completionDate",
        type: "ASC",
        icon: "arrow_upward"
    },
    {
        name: "tasks.completionDateFilter",
        value: "completionDate",
        type: "DESC",
        icon: "arrow_downward"
    }
];

export const TASKS_PRIORITY = {
    highest: {
        name: "tasks.filterBy.priorities.highest",
        value: "highest",
        icon: "mdi-chevron-double-up",
        color: "negative"
    },
    high: {
        label: "tasks.filterBy.priorities.high",
        value: "high",
        icon: "mdi-chevron-up",
        color: "negative"
    },
    normal: {
        label: "tasks.filterBy.priorities.normal",
        value: "normal",
        icon: "mdi-minus",
        color: "warning"
    },
    low: {
        label: "tasks.filterBy.priorities.low",
        value: "low",
        icon: "mdi-chevron-down",
        color: "positive"
    },
    lowest: {
        label: "tasks.filterBy.priorities.lowest",
        value: "lowest",
        icon: "mdi-chevron-double-down",
        color: "positive"
    }
};
